module.exports = __webpack_public_path__ + "static/media/chat.5410add5.svg";